import { useEffect, useRef, useState } from "react";
import {
  Form,
  Button,
  Panel,
  Divider,
  Stack,
  Message,
  useToaster,
} from "rsuite";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../components/axios";
import { showMessage } from "../../components/ToastMessage";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [update, setUpdate] = useState(false);
  const navigate = useNavigate();
  const toaster = useToaster();

  const formData = (formValue) => {
    setEmail(formValue.email);
    setPassword(formValue.password);
  };

  const handleSubmit = async () => {
    const data = { email, password };
    setLoading(true);
    axios
      .post("/auth/authenticate_user", data)
      .then(({ data }) => {
        if (data.status == 401) {
          toaster.push(showMessage("error", "Auth Error: Wrong Credentials"));
          setLoading(false);
        } else if (data.status == 404) {
          toaster.push(
            showMessage("error", "Auth Error: You are not registered"),
          );
          setLoading(false);
        } else {
          localStorage.setItem("user", JSON.stringify(data.result));
          localStorage.setItem("auth_token", data.token);
          navigate("/");
          setLoading(false);
          toaster.push(showMessage("success", "Auth Successful"));
        }
      })
      .catch((err) => {
        toaster.push(showMessage("error", "Netwok Error: Failed to connect!"));
        setLoading(false);
      });
  };

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      direction="column"
      style={{
        height: "100vh",
        backgroundColor: "#f7f7fa",
      }}
    >
      <Panel
        bordered
        style={{ background: "#fff", width: 400 }}
        header={<h3>Sign In</h3>}
      >
        {showMessage}
        <Form onChange={formData} fluid>
          <Form.Group>
            <Form.ControlLabel>Email</Form.ControlLabel>
            <Form.Control name="email" disabled={loading} />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>
              <span>Password</span>
              <a style={{ float: "right" }}>Forgot password?</a>
            </Form.ControlLabel>
            <Form.Control name="password" type="password" disabled={loading} />
          </Form.Group>
          <Form.Group>
            <Stack spacing={6} divider={<Divider vertical />}>
              <Button
                appearance="primary"
                onClick={handleSubmit}
                loading={loading}
              >
                Sign in
              </Button>
            </Stack>
          </Form.Group>
        </Form>
      </Panel>
    </Stack>
  );
};
export default Login;
